module.exports = __webpack_public_path__ + "assets/398595352725391fdfbca16f566dacba.png";